module.exports = __webpack_public_path__ + "img/2.617e40e6.png";